
enum VideoEvents {
    LoadVideoListStarted = "[VideoEvent] LoadVideoListStarted",
    LoadVideoListComplete = "[VideoEvent] LoadVideoListComplete",
    LoadVideoStarted = "[VideoEvent] LoadVideoStarted",
    LoadVideoComplete = "[VideoEvent] LoadVideoComplete",
    CreateStarted = "[VideoEvent] CreateStarted",
    CreateComplete = "[VideoEvent] CreateComplete",
    Update = "[VideoEvent] Update",
    Delete = "[VideoEvent] Delete",
    UploadExtraMaterials = "[VideoEvent] UploadExtraMaterials",
    UploadExtraMaterialsComplete = "[VideoEvent] UploadExtraMaterialsComplete",
    DeleteExtraMaterials = "[VideoEvent] DeleteExtraMaterials",
    // 視聴数カウント
    IncrementViewCount = "[VideoEvent] IncrementViewCount",
    // 視聴履歴登録
    AddViewingHistory = "[VideoEvent] AddViewingHistory",
    ReactStarted = "[VideoEvent] ReactStarted",
    ReactComplete = "[VideoEvent] ReactComplete",
    CommentStarted = "[VideoEvent] CommentStarted",
    CommentComplete = "[VideoEvent] CommentComplete",
    filterVideoListStarted = "[VideoEvent] filterVideoListStarted",
    filterVideoListComplete = "[VideoEvent] filterVideoListComplete",
    getTagListStarted = "[VideoEvent] getTagList",
    getTagListComplete = "[VideoEvent] getTagListComplete",
    // ビデオ追加
    AddVideoStarted = "[VideoEvent] AddVideo",
    AddVideoComplete = "[VideoEvent] AddVideoComplete",
    AddVideoFailed = "[VideoEvent] AddVideoFailed",
    // ビデオ編集
    EditVideoStarted = "[VideoEvent] EditVideo",
    EditVideoComplete = "[VideoEvent] EditVideoComplete",
    EditVideoFailed = "[VideoEvent] EditVideoFailed",
    // ビデオ資料アップロード
    UploadDocumentStarted = "[VideoEvent] UploadDocument",
    UploadDocumentComplete = "[VideoEvent] UploadDocumentComplete",
    UploadDocumentFailed = "[VideoEvent] UploadDocumentFailed",
    // ビデオ削除
    DeleteVideoStarted = "[VideoEvent] DeleteVideo",
    DeleteVideoComplete = "[VideoEvent] DeleteVideoComplete",
    DeleteVideoFailed = "[VideoEvent] DeleteVideoFailed",
    // ビデオデータリセット
    ResetVideos = "[VideoEvent] ResetVideos",
    ResetVideo = "[VideoEvent] ResetVideo",
    // ビデオスライド資料取得
    GetVideoSlide = "[VideoEvent] GetVideoSlide",
    GetVideoSlideComplete = "[VideoEvent] GetVideoSlideComplete",

    // ビデオスライド資料追加
    UploadVideoSlideStarted = "[VideoEvent] UploadVideoSlide",
    UploadVideoSlideFailed = "[VideoEvent] UploadVideoSlideFailed",
    UploadVideoSlideComplete = "[VideoEvent] UploadVideoSlideComplete",

    // ビデオスライド資料編集
    EditVideoSlideStarted = "[VideoEvent] EditVideoSlide",
    EditVideoSlideFailed = "[VideoEvent] EditVideoSlideFailed",
    EditVideoSlideComplete = "[VideoEvent] EditVideoSlideComplete",

    // ビデオスライド資料削除
    DeleteVideoSlideStarted = "[VideoEvent] DeleteVideoSlide",
    DeleteVideoSlideFailed = "[VideoEvent] DeleteVideoSlideFailed",
    DeleteVideoSlideComplete = "[VideoEvent] DeleteVideoSlideComplete",

    // ローディング表示
    VisibleLoading = "[VideoEvent] VisibleLoading",
    InvisibleLoading = "[VideoEvent] InvisibleLoading",

    // 多言語の字幕情報取得
    GetVideoCurrentSubtitleStarted = "[VideoEvent] GetVideoCurrentSubtitleStarted",
    GetVideoCurrentSubtitleComplete = "[VideoEvent] GetVideoCurrentSubtitleComplete",
    SetCurrentVideoCaptions = "[VideoEvent] SetCurrentVideoCaptions",
}

export default VideoEvents;
